export default __webpack_public_path__ + "static/media/tractor__normal.f88e5b15.svg";